export const SET_OPEN_VFD_TASKS = 'SET_OPEN_VFD_TASKS'
export const REMOVE_OPEN_VFD_TASK = 'REMOVE_OPEN_VFD_TASK'

export const SET_VFD_PATIENT_TOKEN = 'SET_VFD_PATIENT_TOKEN'
export const SET_VFD_PATIENT_DETAILS = 'SET_VFD_PATIENT_DETAILS'

export const SET_VFD_AMD_PATIENT_TOKEN = 'SET_VFD_AMD_PATIENT_TOKEN'
export const SET_VFD_AMD_PATIENT_DETAILS = 'SET_VFD_AMD_PATIENT_DETAILS'

export const initialState: VfdState = {
  vfdOpenTasks: [],
  vfdPatientAuth: {
    patient: null,
    patientToken: null,
  },
  vfdAmdPatientAuth: {
    patient: null,
    patientToken: null,
  },
}
